import React from "react";
import Icon from "./Icon";

function DragDropOverlay({ visible }) {
  if (!visible) return null;
  return (
    <div className="drag-drop-overlay gd-drag-overlay">
      <div className="drag-drop-content">
        <Icon name="cloudUpload" size={56} />
        <h3>Drop files to upload</h3>
        <p>Files will be added to the current folder</p>
      </div>
    </div>
  );
}

export default DragDropOverlay;
